<div class="questionnaire-review">
  @if (!hideHeader) {
    <h2 class="review-heading">Review your answers</h2>
    <p class="review-subheading">Reporting period: <strong>{{ periodLabel }}</strong></p>
    @if (submission?.status === 'pending_review') {
      <p class="review-notice">Your answers will be reviewed by OECD staff before being published.</p>
    }
    @if (submission?.status === 'published' || submission?.status === 'unchanged') {
      <p class="review-notice">
        Your report is published.
        <a [href]="apiBaseUrl + '/transparency-reports/' + submission.id + '/public'" target="_blank" rel="noopener noreferrer">View public report</a>
        &middot;
        <a [href]="apiBaseUrl + '/transparency-reports/' + submission.id + '/view-pdf'" target="_blank" rel="noopener noreferrer">Download PDF</a>
      </p>
    }
  }

  <div class="review-card">
    @for (section of questionnaire; track section.id) {
      <article class="message is-light review-section">
        <div class="message-header review-section-header">
          <p>Section {{ section.sectionNumber }} - {{ section.title }}</p>
        </div>

        <div class="message-body p-0">
          @for (question of section.questions; track question.id) {
            @if (!question.parentQuestionId) {
              <div class="media review-question p-4">
                <div class="media-content">
                  <div
                    class="content mb-2 review-question-title"
                    [innerHTML]="formatPrefix(question.prefix) + question.title"
                  ></div>

                  @if (question.type !== 'empty') {
                    @if (hasAnswer(question.id)) {
                      <div class="content review-answer" [innerHTML]="getFormattedAnswer(question)"></div>
                    } @else {
                      @if (question.required) {
                        <p class="help is-danger mb-0">
                          <i class="icon icon-alert-triangle mr-1"></i>Missing answer
                        </p>
                      } @else {
                        <p class="help mb-0">No answer provided</p>
                      }
                    }
                  }

                  @if (question.collectRefs) {
                    @for (ref of getToolReferences(question.id); track ref.id) {
                      <span class="tag is-info is-light mr-2 mb-2">
                        <i class="icon icon-grid mr-1"></i>{{ ref.name }}
                      </span>
                    }
                    @for (ref of getMetricReferences(question.id); track ref.id) {
                      <span class="tag is-link is-light mr-2 mb-2">
                        <i class="icon icon-bar-chart mr-1"></i>{{ ref.name }}
                      </span>
                    }
                  }

                  @if (question.children?.length) {
                    @for (child of question.children; track child.id) {
                      @if (isQuestionVisible(child)) {
                        <div class="review-sub-question mt-4 ml-4">
                          <div
                            class="content mb-2 review-question-title is-size-7"
                            [innerHTML]="formatPrefix(child.prefix) + child.title"
                          ></div>

                          @if (child.type !== 'empty') {
                            @if (hasAnswer(child.id)) {
                              <div class="content review-answer" [innerHTML]="getFormattedAnswer(child)"></div>
                            } @else {
                              @if (child.required) {
                                <p class="help is-danger mb-0">
                                  <i class="icon icon-alert-triangle mr-1"></i>Missing answer
                                </p>
                              } @else {
                                <p class="help mb-0">No answer provided</p>
                              }
                            }
                          }

                          @if (child.collectRefs) {
                            @for (ref of getToolReferences(child.id); track ref.id) {
                              <span class="tag is-info is-light mr-2 mb-2">
                                <i class="icon icon-grid mr-1"></i>{{ ref.name }}
                              </span>
                            }
                            @for (ref of getMetricReferences(child.id); track ref.id) {
                              <span class="tag is-link is-light mr-2 mb-2">
                                <i class="icon icon-bar-chart mr-1"></i>{{ ref.name }}
                              </span>
                            }
                          }
                        </div>
                      }
                    }
                  }
                </div>

                @if (!readOnly) {
                  <div class="media-right">
                    <button
                      type="button"
                      class="button is-small is-white review-edit-button"
                      title="Edit this section"
                      (click)="onEditSection(section.sectionNumber)"
                    >
                      <i class="icon icon-edit"></i>
                    </button>
                  </div>
                }
              </div>
            }
          }
        </div>
      </article>
    }
  </div>
</div>

